/* eslint-disable no-prototype-builtins */
import { AngleDownIcon, CloseIcon } from '../Icons';
import { Box, makeStyles } from '@material-ui/core';
import { Autocomplete as MuiAutocomplete } from '@material-ui/lab';
import { useSize } from '../..';
import { Text } from '../Text';
import DropdownChip from '../DropdownChip';
import React, { Fragment } from 'react';
import flatten from 'lodash/flatten';
const useStyles = makeStyles(({ palette, spacing }) => ({
    icon: {
        marginRight: spacing(1),
        color: palette.text.secondary,
    },
    divider: {
        marginLeft: spacing(-3),
    },
    inputRootMulti: {
        paddingLeft: `${spacing(2)}px !important`,
    },
    inputRootSingle: {
        paddingLeft: `${spacing(1.5)}px !important`,
    },
    smallInputRootMulti: {
        paddingLeft: `${spacing(2)}px !important`,
        paddingTop: `${spacing(0)}px !important`,
    },
    smallInputRootSingle: {
        paddingLeft: `${spacing(1.5)}px !important`,
        paddingTop: `${spacing(0)}px !important`,
    },
    endAdornment: {
        top: '0 !important',
    },
}));
var timer;
function debounce(cb, duration) {
    return function (..._) {
        const arg_data = arguments;
        clearTimeout(timer);
        timer = setTimeout(function () {
            cb.apply(null, arg_data);
        }, duration);
    };
}
function getOptionLabel(option) {
    if (Array.isArray(option))
        return '';
    if (option && option.hasOwnProperty('label') && typeof option !== 'string') {
        return option.label;
    }
    else if (typeof option === 'string') {
        return option;
    }
    return '';
}
function MultipleAutocomplete(props) {
    const { invalid, helperText, freeSolo, onChange, inputValue, onInputChange, value, options, label, disabled, onBlur, onFocus, size, clearOnBlur, autoSelect, blurOnSelect, variant, loading, background, } = props;
    const classes = useStyles();
    const [currentInputValue, setInputValue] = React.useState(inputValue);
    const [open, setOpen] = React.useState(false);
    const { size: contextSize } = useSize();
    const realSize = contextSize || size || 'medium';
    const needsLabel = variant !== 'standard';
    const needsPlaceholder = realSize === 'small' || variant === 'standard';
    const changeInputValue = (data) => {
        onInputChange && onInputChange(data);
        setInputValue(data);
    };
    const onInputValueChange = (event, data) => {
        if (event !== null) {
            changeInputValue(data);
        }
    };
    const renderValueMultiple = (selected) => {
        const selectedSafe = Array.isArray(selected) ? selected : [];
        const selectedOptions = freeSolo ? selectedSafe : selectedSafe.filter(v => typeof v !== 'string');
        const safeValueList = value || [];
        const renderedOptions = selectedOptions.map(option => {
            if (option && option.hasOwnProperty('label') && typeof option !== 'string') {
                const concreteSelected = option;
                const deleteValue = () => {
                    onChange &&
                        onChange(safeValueList.filter(v => (typeof v !== 'string' && v && v.value !== concreteSelected.value) || typeof v === 'string'));
                };
                return React.createElement(DropdownChip, { key: concreteSelected.label, label: concreteSelected.label, onDelete: deleteValue });
            }
            const concreteSelected = option;
            const deleteValue = () => {
                const newValue = safeValueList.filter(v => v !== concreteSelected);
                onChange && onChange(newValue);
            };
            return React.createElement(DropdownChip, { key: concreteSelected, label: concreteSelected, onDelete: deleteValue });
        });
        return React.createElement(Fragment, null, renderedOptions);
    };
    const handleBlur = (event) => {
        if (clearOnBlur) {
            clearInputValue();
        }
        onBlur && onBlur(event);
    };
    const clearInputValue = () => {
        changeInputValue('');
    };
    const onOpen = () => {
        setOpen(true);
    };
    const onClose = () => {
        setOpen(false);
    };
    return (React.createElement(MuiAutocomplete, { loading: loading, renderInput: (params) => (React.createElement(Text, Object.assign({}, params, { label: needsLabel ? label : undefined, helperText: helperText, error: !!invalid, onBlur: handleBlur, onFocus: onFocus, variant: variant, fullWidth: true, placeholder: needsPlaceholder ? label : undefined, background: background }))), renderTags: (values) => renderValueMultiple(values), popupIcon: React.createElement(AngleDownIcon, { fontSize: "small", className: classes.icon }), multiple: true, freeSolo: freeSolo, value: flatten(value), disabled: disabled, options: options, autoSelect: autoSelect, blurOnSelect: blurOnSelect, autoHighlight: true, autoComplete: true, closeIcon: React.createElement("div", null,
            React.createElement(CloseIcon, { fontSize: "small", onClick: clearInputValue })), classes: {
            inputRoot: realSize === 'medium' ? classes.inputRootMulti : classes.smallInputRootMulti,
            endAdornment: variant === 'standard' ? classes.endAdornment : undefined,
        }, inputValue: currentInputValue || '', onInputChange: onInputValueChange, getOptionLabel: getOptionLabel, onChange: (_, newValue) => {
            onChange && onChange(newValue);
        }, open: open, onClose: onClose, onOpen: onOpen }));
}
function SingleAutocomplete(props) {
    const { invalid, helperText, freeSolo, onChange, inputValue, onInputChange, value, options, label, disabled, onBlur, onFocus, size, renderOption, autoSelect, clearOnBlur, blurOnSelect, variant, loading, background, } = props;
    const [currentInputValue, setInputValue] = React.useState(inputValue);
    const [open, setOpen] = React.useState(false);
    const classes = useStyles();
    const { size: contextSize } = useSize();
    const realSize = contextSize || size || 'medium';
    const needsLabel = variant !== 'standard';
    const needsPlaceholder = realSize === 'small' || variant === 'standard';
    const clearAndChange = (data) => {
        clearTimeout(timer);
        onChange && onChange(data);
    };
    const handleChange = (event, data) => {
        if (data !== undefined) {
            clearAndChange(data);
        }
    };
    const saveIfNeeded = (data) => {
        if (freeSolo) {
            const changeFn = onChange;
            (!value || !value.hasOwnProperty('label')) && onChange && changeFn(data);
        }
    };
    const debouncedSave = debounce(saveIfNeeded, 200);
    const changeInputValue = (data) => {
        onInputChange && onInputChange(data);
        setInputValue(data);
        debouncedSave(data);
    };
    const onInputValueChange = (event, data) => {
        if (event !== null) {
            changeInputValue(data);
        }
    };
    const handleBlur = (event) => {
        if (freeSolo) {
            if (typeof value === 'string' || value === undefined) {
                clearAndChange(currentInputValue || '');
            }
            else {
                const label = value ? value.label : undefined;
                const valueLength = label ? label.length : 0;
                const labelContainsInput = currentInputValue && label ? label.toLowerCase().includes(currentInputValue.toLowerCase()) : false;
                if (valueLength < (currentInputValue || '').length && labelContainsInput) {
                    clearAndChange(currentInputValue || '');
                }
            }
        }
        if (clearOnBlur) {
            clearInputValue();
        }
        onBlur && onBlur(event);
    };
    const clearInputValue = () => {
        changeInputValue('');
    };
    const onOpen = () => {
        setOpen(true);
    };
    const onClose = () => {
        setOpen(false);
    };
    return (React.createElement(MuiAutocomplete, { loading: loading, renderInput: (params) => (React.createElement(Text, Object.assign({}, params, { label: needsLabel ? label : undefined, helperText: helperText, error: !!invalid, onBlur: handleBlur, onFocus: onFocus, fullWidth: true, variant: variant, placeholder: needsPlaceholder ? label : undefined, background: background }))), popupIcon: React.createElement(AngleDownIcon, { fontSize: "small", className: classes.icon }), freeSolo: freeSolo, value: value, disabled: disabled, options: options, renderOption: renderOption, autoSelect: autoSelect, blurOnSelect: blurOnSelect, autoHighlight: true, autoComplete: true, onBlur: onBlur, closeIcon: React.createElement("div", null,
            React.createElement(CloseIcon, { fontSize: "small", onClick: clearInputValue })), classes: {
            inputRoot: realSize === 'medium' ? classes.inputRootSingle : classes.smallInputRootSingle,
            endAdornment: variant === 'standard' ? classes.endAdornment : undefined,
        }, inputValue: currentInputValue || undefined, onInputChange: onInputValueChange, getOptionLabel: getOptionLabel, onChange: handleChange, open: open, onClose: onClose, onOpen: onOpen }));
}
export function Autocomplete(props) {
    const { multiple, ...rest } = props;
    return (React.createElement(Box, { mb: 1 }, multiple ? (React.createElement(MultipleAutocomplete, Object.assign({}, rest))) : (React.createElement(SingleAutocomplete, Object.assign({}, rest)))));
}
//# sourceMappingURL=Autocomplete.js.map